import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

import { respondAbove } from 'styles/mediaQueries'

export const RoomTileWrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_100};
    min-height: 182px;
    width: 100%;
    border-radius: 8px;

    > div:first-child {
        border-bottom: 2px solid ${({ theme }) => theme.colors.grayscale_200};
    }

    @media ${respondAbove.xl} {
        > div:first-child {
            border-bottom: 0;
        }
    }
`

export const CtaWrapper = styled.div`
    button {
        min-width: auto;
        max-width: 116px;
    }

    @media ${respondAbove.xl} {
        button {
            margin-top: 12px;
            min-width: 132px;
        }
    }
`

export const RoomTileGallery = styled.div`
    width: 64px;
    min-width: 64px;
    height: 64px;
    border-radius: 8px;
    overflow: hidden;

    @media ${respondAbove.xl} {
        width: 182px;
        min-width: 182px;
        min-height: 182px;
        height: auto;
        border-radius: 8px 0 0 8px;
    }
`
